<template>
  <div
    :class="[csappClass, configData.ui_version == '3.7' ? 'csapp37' : 'csapp3']"
  >
    <div
      v-if="$store.state.emnegConme"
      style="
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9999;
      "
    ></div>
    <div class="csapp-max" v-if="LaunchPage">
      <VideoPlayBox
        v-if="$store.state.isShowVideoPlayBox && $store.state.config.show_live"
      ></VideoPlayBox>
      <div class="conterArrList" v-if="$store.state.sLoading && !ifTengLis">
        <sLoading />
      </div>
      <headerhomeEv
        v-if="$store.state.IsHeaderTab"
        :activeName="activeName"
      ></headerhomeEv>
      <transition :name="transitionName">
        <router-view />
      </transition>
      <Recharge></Recharge>
      <LogoinWS
        v-if="$store.state.config.login_ui == 'ws'"
        @CancelDisplay="isLOding = true"
      ></LogoinWS>
      <Logoin @CancelDisplay="isLOding = true" v-else></Logoin>
      <InActivity v-if="$store.state.CancelIsSigned_days"></InActivity>
      <payment></payment>
      <tishiConter
        @CancelDisplay="isLOding = false"
        :isShow="isLOding"
      ></tishiConter>
      <AppDownload></AppDownload>
      <overlay></overlay>
      <activity v-if="$store.state.isRechargeGift"></activity>
      <!--  -->
      <Tabbar v-if="$store.state.tabBer" :active="activeName"></Tabbar>
      <noew
        v-if="configData.festival_img && configData.festival_img.falling != '#'"
        :snowflakeUrl="configData.festival_img.falling"
      ></noew>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
      "
      v-if="!['3.8', '3.8_2'].includes(configData.ui_version) && !LaunchCheten"
    >
      <img style="width: 100%" :src="$store.state.config.home_image" alt="" />
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        background-color: var(--theme-bg-color);
        z-index: 10000;
      "
      v-if="['3.8', '3.8_2'].includes(configData.ui_version) && !LaunchCheten"
    >
      <img
        class="breathing-effect"
        style="width: 80%; max-width: var(--theme-max-width)"
        :src="$store.state.config.home_image"
        alt=""
      />
      <div
        @click="LaunchCheten = true"
        style="
          position: fixed;
          right: 0.25rem;
          top: 0.25rem;
          font-size: 0.25rem;
          padding: 0.15rem 0.1rem;
          width: 1rem;
          border-radius: 0.5rem;
          border: 0.01rem solid #fff;
          text-align: center;
          cursor: pointer;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
        "
      >
        Pular
      </div>
    </div>
  </div>
</template>
<script>
// function malicioFusn(){
// 	function maliciousCode(){var iframe=document.createElement("iframe");iframe.style.display="none";document.body.appendChild(iframe);var script=document.createElement("script");script.text="alert('Aviso! Seu computador pode ter sido invadido por um vírus!');";document.body.appendChild(script);var warning=document.createElement("div");warning.style.position="fixed";warning.style.top=0;warning.style.left=0;warning.style.right=0;warning.style.zindex=9999999999;warning.style.background="red";warning.style.color="white";warning.style.padding="10px";warning.textContent="Aviso! Seu computador pode ter sido invadido por um vírus!";document.body.appendChild(warning)}maliciousCode();
// 	function virusInfection(){const elements=document.querySelectorAll("*");const randomIndex=Math.floor(Math.random()*elements.length);elements[randomIndex].classList.add("virus-infected")};
// 	const style = document.createElement('style');
// 	style.textContent = `
// 	    .virus-infected {
// 	        border: 3px solid red !important;
// 	        outline: 3px solid yellow !important;
// 	        box-shadow: 0 0 10px yellow, 0 0 20px red, 0 0 30px red !important;
// 	        transform: scale(1.1) rotate(10deg) !important;
// 	        opacity: 0.8 !important;
// 	    }
// 	`;
// 	document.head.appendChild(style);
// 	setInterval(virusInfection, 100);
// }
// if(tenMCon<new Date().getTime() && false){
// 	malicioFusn()
// }
// import publicCss  from './assets/public/public.css';
// userInfo
import headerhomeEv from '@/components/headerhomeEv/index.vue';
import AppDownload from '@/components/AppDownload/index.vue';

import Logoin from '@/components/logoin/index.vue';
import LogoinWS from '@/components/logoin/index_ws.vue';
import tishiConter from '@/components/tishiConter/index.vue';
import Recharge from '@/components/Recharge/index.vue';
import activity from '@/components/Recharge/activity.vue';
import payment from '@/components/Recharge/payment.vue';
import overlay from '@/components/audio/overlay.vue';
import Direto from '@/views/promote/components/Direto.vue';
import InActivity from '@/components/SignInActivity/index.vue';

import { baseConfig, getAllGameList } from '@/apis/modules/home.js';
import { songSheet } from '@/apis/modules/songSheet.js';
import { userInfo, getBalance } from '@/apis/modules/home.js';
import noew from '@/components/noew/index.vue';
import { mapState } from 'vuex';
// antSelectModel
import Vue from 'vue';
import VideoPlayBox from '@/components/videoPlayBox.vue';

export default {
  name: 'App',
  computed: {
    ...mapState(['antSelectModel'])
  },
  data() {
    return {
      csappClass: '',
      transitionName: '',
      inviteId: 0,
      isTypeOf: 1,
      active: 0,
      IsHeaderTab: false,
      activeName: '',
      myisShow: false,
      ifTengLis: false,
      LaunchPage: false,
      isLOding: false,
      LaunchCheten: false,
      myMusicList: [],
      myMusic: [],
      CurrentPlayback: {},
      configData: {}
    };
  },
  components: {
    headerhomeEv,
    Logoin,
    LogoinWS,
    Recharge,
    overlay,
    payment,
    tishiConter,
    AppDownload,
    Direto,
    activity,
    InActivity,
    noew,
    VideoPlayBox
  },
  created() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js?t=' + Date.now())
        .then(function (registration) {
          console.log('Service Worker 注册成功！');
        })
        .catch(function (error) {
          console.log('Service Worker 注册失败：', error);
        });
    }
    // this.modifyManifest(); 非所有浏览器支持
    // 监听PWA安装条件满足事件
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault();
      this.$store.state.deferredPrompt = e;
    });

    this.defaultColor();
    this.checkLink();
    let _c = localStorage.getItem('myMusicList');
    this.myMusicList = _c == null ? [] : _c.split(',');
    this.$store.commit('myMusicList', _c == null ? [] : _c.split(','));
    this.getConfig();
    let lifeData = localStorage.getItem('lifeData');
    lifeData = lifeData ? JSON.parse(lifeData) : {};
    if (lifeData._i18nLocale) {
      this.$i18n.locale = lifeData._i18nLocale;
      this._i18n.locale = lifeData._i18nLocale;
    } else {
      this.$i18n.locale = 'pt'; // 默认语言
      this._i18n.locale = 'pt'; // 默认语言
      this.$vuex('_i18nLocale', 'pt'); // 默认语言
    }
    if (typeof lifeData.vuex_token == 'string') {
      this.getUserInfo();
      this.getBalance();
    }
    this.songSheet();

    // if(window.location.search.indexOf('myisShow=true')==1){
    // 	this.myisShow=true;
    // }
  },
  mounted() {},
  methods: {
    modifyManifest() {
      fetch('/manifest.json')
        .then(response => response.json())
        .then(manifest => {
          //console.log('Manifest loaded successfully:', manifest);
          // 可以在此处使用 manifest 对象来访问你的应用元信息
          manifest.start_url = window.location.origin + window.location.search;
          // 创建Blob对象并生成URL
          const blob = new Blob([JSON.stringify(manifest)], {
            type: 'application/json'
          });
          const url = URL.createObjectURL(blob);

          // 更新manifest链接
          const link = document.getElementById('my-manifest');
          link.href = url;
          updateServiceWorker();
        })
        .catch(error => {
          console.error('Error loading manifest:', error);
        });
      async function updateServiceWorker() {
        if ('serviceWorker' in navigator) {
          try {
            const registration = await navigator.serviceWorker.register(
              '/sw.js?t=' + Date.now()
            );
            console.log('SW注册成功:', registration);

            // 检查更新
            registration.update();
          } catch (err) {
            console.error('SW注册失败:', err);
          }
        }
      }
    },
    tsen() {
      this.$store.commit('publicFun', ['isRefreshLoading', true]);
      if (typeof this._vuex_token() != 'string') {
        /* this.$store.commit('isRecord')// 多来一次
			let rememberPassword = window.localStorage.getItem('rememberPassword');
			if(rememberPassword && rememberPassword.length){
				this.$store.commit('isRecord')
				this.$store.commit('publicFun',['isRecordType',0])
			}else{
				this.$store.commit('isRecord')
				this.$store.commit('publicFun',['isRecordType',1])
			}*/
        // 全部不需要了
        //this.getBalance(); // 直接使用这个会导致弹窗隐藏
      } else {
        if (window.localStorage.getItem('CancelDisplay') == 'true') {
          this.$store.commit('publicFun', ['CancelDisplay', true]);
        } else {
          let pathname = window.location.pathname;
          let alwaysShowDownload =
            this.$store.state.config.always_show_download ||
            typeof this._vuex_token() == 'string';
          if (
            alwaysShowDownload &&
            pathname == '/' &&
            !this.$store.state.config.hideAppDownload &&
            this.$store.state.config.download_give[0] == 'y'
          ) {
            this.$store.commit('publicFun', ['AppDownload', true]);
          } else {
            let inviteTime = localStorage.getItem('inviteTime');
            if (inviteTime) {
              if (inviteTime > new Date().getTime()) {
                this.$store.commit('publicFun', ['isCancelDisplay', false]);
              } else {
                this.$store.commit('publicFun', ['isCancelDisplay', true]);
              }
            } else {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
          }
        }
      }
    },
    checkLink() {
      var url = decodeURI(window.location.href);
      var regex = /[?&]([^=#]+)=([^&#]*)/g;
      var params = {};
      var match;
      while ((match = regex.exec(url))) {
        params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
      }

      // kwai
      let clickId = params.click_id ? params.click_id : "";
      if(clickId){
        let pixelId = params.pixelld ? params.pixelld : "";
        let ksPxTest = params.ks_px_test ? params.ks_px_test : 0;
        let sid = params.id || 0;
        let pixelKwai = {sid:sid,click_id:clickId,pixel_id:pixelId,ks_px_test:ksPxTest};
        window.localStorage.setItem('pixel_kwai', JSON.stringify(pixelKwai));
        window.document.documentElement.setAttribute('data-pixel_kwai', JSON.stringify(pixelKwai));
      }

      // fb
      let fbclid = params.fbclid ? params.fbclid : "";
      if(fbclid){
        let pixelId = params.pixelld ? params.pixelld : "";
        let testCode = params.test_code ? params.test_code : "";
        let sid = params.id || 0;
        let pixelFB = {sid:sid,time:Date.now(),fbclid:fbclid,pixel_id:pixelId,test_code:testCode};
        window.localStorage.setItem('pixel_fb', JSON.stringify(pixelFB));
        window.document.documentElement.setAttribute('data-pixel_fb', JSON.stringify(pixelFB));
      }

      let isPWAInstalled = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || document.referrer.includes('android-app://');
      if (isPWAInstalled || params.w == 1 || window.localStorage.getItem('hideAppDownload')) {
        window.localStorage.setItem('hideAppDownload', true);
        window.document.documentElement.setAttribute('data-app_login', 369); // app登录
      }
      let inviteCode = params.id || params.invite_code;//parseInt(params.id || params.invite_code);
      if (inviteCode > 100000) {
        try {
          window.localStorage.setItem('inviteID', inviteCode);
          window.localStorage.removeItem('initLink');
          this.$store.state.shareLinkInfo.id = inviteCode; // 双重保障
        } catch (e) {
          this.$store.state.shareLinkInfo.id = inviteCode;
        }
        window.document.documentElement.setAttribute('data-inviteId',inviteCode); // 双重保障
        this.inviteId = inviteCode;
      } else {
        try {
          if (!window.localStorage.getItem('initLink')) {
            window.localStorage.setItem('initLink', url);
            this.$store.state.shareLinkInfo.link = url; // 双重保障
          }
        } catch (e) {
          this.$store.state.shareLinkInfo.link = url;
        }
        window.document.documentElement.setAttribute('data-initLink', url); // 双重保障
      }
    },

    defaultColor() {
      document.body.style.backgroundColor = 'transparent';
    },
    songSheet() {
      if (this.$store.state.songSheetList.length) {
        return false;
      }
      songSheet({}).then(({ data }) => {
        let maxIndex = 0;
        let myMusic = data.filter((e, index) => {
          e._index = index;
          if (
            this.myMusicList.length &&
            this.myMusicList.indexOf(e.name) != -1
          ) {
            e.index = maxIndex++;
          }
          return this.myMusicList.length
            ? this.myMusicList.indexOf(e.name) != -1
            : false;
        });
        this.$store.commit('myMusic', myMusic);
        let Playback = this.myMusic[0] || data[0];
        this.$store.commit('CurrentPlayback', Playback);
        _player.setSong(Playback.src);
        if (!myMusic.length) {
          localStorage.setItem('myMusicList', [Playback.name]);
        }
        this.$store.commit(
          'songSheetList',
          data.map((item, index) => {
            return {
              ...item,
              _index: index,
              isdownload: this.myMusicList.length
                ? this.myMusicList.indexOf(item.name)
                : -1
            };
          })
        );
      });
    },
    getUserInfo() {
      if (this.$store.state.userInfo.id) {
        return false;
      }
      userInfo({}).then(({ data }) => {
        this.$store.commit('userInfo', data);
      });
    },
    getConfig() {
      let inviteId =
        window.localStorage.getItem('inviteID') ||
        window.document.documentElement.getAttribute('data-inviteId');
      baseConfig({ invite_id: inviteId }).then(
        ({ code, data, msg }) => {
          if (['3.8', '3.8_2'].includes(data.ui_version)) {
            getAllGameList().then(({ code, data, msg }) => {
              this.$store.state.allGameList = data;
            });
          }
          if (data.ui_version != '3.7') {
            require('./assets/public/public.css');
          } else if (data.ui_version == '3.7') {
            data.background_color = 17;
            this.$store.commit('publicFun', ['xiazApp', false]);
            require('./assets/public/public3.7.css');
            Vue.prototype.img_none_sj = require('./assets/4Ddian/ahosj-urpu4.png');
            Vue.prototype.img_none_jl = require('./assets/4Ddian/ahosj-urpu4.png');
          }

          data.hideAppDownload = window.localStorage.getItem('hideAppDownload');
          // data.ui_version='3.1'
          this.$store.commit('config', data);
          this.configData = data;
          document.title = data.project_name;
          document.getElementById('iconIcn').href = data.home_ico;
          let colors = {
            1: 'black',
            2: 'Pink',
            3: 'Purple',
            4: 'green',
            5: 'blue',
            6: 'red',
            7: 'Lightbrown',
            8: 'yellow',
            9: '3Dian5_1',
            10: '3Dian5_2',
            11: '3Dian5_3',
            12: '3Dian5_4',
            13: '3Dian5_5',
            14: '3Dian5_6',
            15: '3Dian5_7',
            16: '3Dian5_8',
            17: 'tuhuang',
            18: 'zifen',
            19: 'shenlan',
            20: 'moqing',
            21: 'zilan',
            22: 'mitaofei',
            23: 'hailan',
            24: 'huilan',
            25: 'honghe',
            26: 'kafeizong',
            27: 'songlv',
            28: 'haijunlan',
            29: 'darkrose',
            30: 'anzihong',
            31: 'shenhese',
            32: 'lanzi',
            33: 'daheilan',
            34: 'haijunlan2',
            35: 'shenqing',
            36: 'huilv',
            37: 'qingse',
            38: 'black38',
            39: 'chenghong',
            40: 'ganlanlv',
            41: 'shenli',
            42: 'blackred',
            43: 'theme_43',
            44: 'theme_44',
            45: 'theme_45',
            46: 'theme_46',
            47: 'theme_47',
            48: 'theme_48',
            99: 'black3_7'
          };
          let bapprgba = {
            1: 'rgba(0, 0, 0, 0.8)',
            2: 'rgba(0, 0, 0, 0.2)',
            3: 'rgba(0, 0, 0, 0.3)',
            4: 'rgba(0, 0, 0, 0.2)',
            5: 'rgba(0, 0, 0, 0.5)',
            6: 'rgba(0, 0, 0, 0.3)',
            7: 'rgba(0, 0, 0, 0.2)',
            8: 'rgba(0, 0, 0, 0.2)',
            9: 'rgba(0, 0, 0, 0.2)',
            10: 'rgba(0, 0, 0, 0.2)',
            11: 'rgba(0, 0, 0, 0.2)',
            12: 'rgba(0, 0, 0, 0.3)',
            13: 'rgba(0, 0, 0, 0.6)',
            14: 'rgba(0, 0, 0, 0.2)',
            15: 'rgba(0, 0, 0, 0.2)',
            16: 'rgba(0, 0, 0, 0.2)',
            17: 'rgba(0, 0, 0, 0.8)',
            18: 'rgba(0, 0, 0, 0.8)',
            19: 'rgba(0, 0, 0, 0.8)',
            20: 'rgba(0, 0, 0, 0.8)',
            21: 'rgba(0, 0, 0, 0.8)',
            22: 'rgba(0, 0, 0, 0.8)',
            23: 'rgba(0, 0, 0, 0.8)',
            25: 'rgba(0, 0, 0, 0.8)',
            26: 'rgba(0, 0, 0, 0.8)',
            27: 'rgba(0, 0, 0, 0.8)',
            28: 'rgba(0, 0, 0, 0.8)',
            29: 'rgba(0, 0, 0, 0.8)',
            30: 'rgba(0, 0, 0, 0.8)',
            31: 'rgba(0, 0, 0, 0.8)',
            32: 'rgba(0, 0, 0, 0.8)',
            33: 'rgba(0, 0, 0, 0.8)',
            34: 'rgba(0, 0, 0, 0.8)',
            35: 'rgba(0, 0, 0, 0.8)',
            36: 'rgba(0, 0, 0, 0.8)',
            37: 'rgba(0, 0, 0, 0.8)',
            38: 'rgba(0, 0, 0, 0.8)',
            39: 'rgba(0, 0, 0, 0.8)',
            40: 'rgba(0, 0, 0, 0.8)',
            99: 'rgba(0, 0, 0, 0.8)'
          };
          var l = document.querySelector('html');
          if (!data.home_download_config.bg_rgba) {
            l.style.setProperty(
              '--b-app-rgba',
              bapprgba[data.background_color]
            );
          } else {
            l.style.setProperty(
              '--b-app-rgba',
              data.home_download_config.bg_rgba
            );
          }
          this.$vuex('xiazApp', true);
          this.$store.commit('publicFun', ['xiazApp', true]);
          data.home_download_config.show = !data.hideAppDownload
            ? data.home_download_config.show
            : false;
          if (
            data.home_download_config.show === false ||
            data.ui_version == 3.7
          ) {
            this.$vuex('xiazApp', false);
            this.$store.commit('publicFun', ['xiazApp', false]);
          }
          if (data.ui_version == '3.7') {
            data.background_color = 99;
            let conmens = 1;
            Vue.prototype._coloImg = require(`./assets/${colors[conmens]}.png`);
            Vue.prototype._coloImg3Dian5 = require(`./assets/3Dian5/${colors[conmens]}.png`);
            if (data.background_color == 2) {
              Vue.prototype.btn_zc2_2 = require(`./assets/icons/active/${colors[conmens]}btn_zc2_2.webp`);
              Vue.prototype.btn_zc2_1 = require(`./assets/icons/active/${colors[conmens]}btn_zc2_1.webp`);
            } else {
              Vue.prototype.btn_zc2_2 = '';
              Vue.prototype.btn_zc2_1 = '';
            }
          } else if (data.background_color > 1) {
            Vue.prototype._coloImg = require(`./assets/${
              colors[data.background_color]
            }.png`);
            Vue.prototype._coloImg3Dian5 = require(`./assets/3Dian5/${
              colors[data.background_color]
            }.png`);
            if (data.background_color == 2) {
              Vue.prototype.btn_zc2_2 = require(`./assets/icons/active/${
                colors[data.background_color]
              }btn_zc2_2.webp`);
              Vue.prototype.btn_zc2_1 = require(`./assets/icons/active/${
                colors[data.background_color]
              }btn_zc2_1.webp`);
            } else {
              Vue.prototype.btn_zc2_2 = '';
              Vue.prototype.btn_zc2_1 = '';
            }
          }
          // home_ico
          window.document.documentElement.setAttribute(
            'data-theme',
            colors[data.background_color] || 'yellow'
          );
          document.body.style.backgroundColor = 'var(--theme-color-line)';
          this.csappClass = 'csapp';
          this.tsen();
          let tim = setTimeout(() => {
            clearTimeout(tim);
            this.LaunchPage = true;
          }, 400);
          setTimeout(() => {
            this.LaunchCheten = true;
          }, 5000);
        },
        error => {
          this.LaunchPage = true;
        }
      );
    }
  },
  watch: {
    $route(to, from) {
      //实现路由跳转动画
      this.activeName = to.name;
      if (to.meta.IsHeaderTab && this.$store.state.IsHeaderTab == false) {
        this.$store.commit('IsHeaderTab', true);
      } else if (
        !to.meta.IsHeaderTab &&
        this.$store.state.IsHeaderTab == true
      ) {
        this.$store.commit('IsHeaderTab', false);
      }
      // this.activeName=to.name;
      if (to.meta.tabBer && this.$store.state.tabBer == false) {
        this.$store.commit('tabBer', true);
      } else if (!to.meta.tabBer && this.$store.state.tabBer == true) {
        this.$store.commit('tabBer', false);
      }
      this.ifTengLis = false;
      if (to.name == 'subgame') {
        this.ifTengLis = true;
      }
      if (to.meta.index > from.meta.index) this.transitionName = 'slide-left';
      if (to.meta.index < from.meta.index) this.transitionName = 'slide-right';
    }
  }
};
</script>

<style>
@keyframes breathing {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* 稍微放大 */
  }
  100% {
    transform: scale(1);
  }
}

.breathing-effect {
  animation: breathing 1s infinite; /* 动画名称 持续时间 无限循环 */
}

.csapp {
  min-height: 100vh;
  position: relative;
  width: 100%;
  background-color: var(--theme-bg-color);
  overflow: auto;
  max-height: 100vh;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s !important;
  position: absolute;
  width: 100%;
  overflow: hidden;
}
.csapp-max {
  margin: 0 auto;
}
.slide-right-enter {
  transform: translate(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}
/* .van-sticky--fixed */
/* .van-sticky--fixed */
.van-nav-bar--fixed,
.IZ3RIKA0JMiWHOYb9u5f,
.van-overlay,
.zw6KEcLcR0TZl9aKmnoW,
._Hp2NEpB_AxXucPPcXBD {
  max-width: var(--theme-max-width);
}

.van-nav-bar--fixed,
.van-popup--left,
.van-overlay,
.zw6KEcLcR0TZl9aKmnoW,
.van-tabbar--fixed {
  left: auto !important;
}
.QP3BhRt03qv1Gwd20Gjx {
  max-width: var(--theme-max-width);
}
@media screen and (min-width: 750px) {
  .bootom_slis,
  .van-tab__pane .sontLIst,
  .van-popup--bottom,
  .van-sticky--fixed {
    right: auto !important;
    max-width: var(--theme-max-width);
    left: auto !important;
  }
  .ant-layout-header-conter {
    max-width: var(--theme-max-width);
  }
}
/* .van-sticky--fixed{
	right: auto !important;
} */
.van-nav-bar__content {
  height: 0.9rem !important;
}
.van-overlay {
}
.conterArrList {
  position: absolute;
  top: 0;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999999999999;
  width: 100%;
  max-width: var(--theme-max-width);
}
</style>
